import { productsReturn } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Form, Input, Select } from 'antd';
import { useEffect } from 'react';

function ProductForm({
  edit,
  productsArr,
  warehouseName,
  form
}: {
  edit?: boolean;
  productsArr: productsReturn[];
  warehouseName?: string;
  form: any;
}) {
  const isEdit = !edit;

  const { Option } = Select;

  return (
    <>
      <div>
        <Form
          form={form}
          name="complex-form"
          initialValues={{ products: productsArr }}
        >
          {productsArr?.map((product: productsReturn, index: number) => (
            <Form.Item
              key={index}
              style={{
                padding: '30px',
                background: '#F9F9F9',
                marginBottom: '20px',
                borderRadius: '10px'
              }}
            >
              <Form.Item
                label="Product Name"
                name={[index, 'productName']}
                style={{
                  display: 'inline-block',
                  width: '40%',
                  marginRight: '30px'
                }}
              >
                <Input
                  className="inputRadious"
                  disabled={isEdit}
                  suffix={index === 0 ? warehouseName : ''}
                />
              </Form.Item>
              <Form.Item
                label="SKU"
                name={[index, 'sku']}
                style={{
                  display: 'inline-block',
                  width: '15%',
                  marginRight: '20px'
                }}
              >
                <Input className="inputRadious" disabled={isEdit} />
              </Form.Item>
              <Form.Item
                label="EAN/UPC"
                name={[index, 'eanUpc']}
                style={{
                  display: 'inline-block',
                  width: '15%',
                  marginRight: '20px'
                }}
              >
                <Input className="inputRadious" disabled={isEdit} />
              </Form.Item>
              <Form.Item
                label="Quantity"
                name={[index, 'quantity']}
                style={{ display: 'inline-block', width: '10%' }}
              >
                <Select className="quantitySelect" disabled={isEdit}>
                  <Option value="a">1개</Option>
                  <Option value="b">2개</Option>
                  <Option value="c">3개</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="id"
                name={[index, 'id']}
                style={{
                  display: 'none',
                }}
              >
                <Input className="inputRadious" disabled={isEdit} />
              </Form.Item>
            </Form.Item>
          ))}
        </Form>
      </div>
    </>
  );
}

export default ProductForm;
